<template>
  <div class="relative w-3/5 text-sm font-medium text-white">
    <button
      class="border-ontick-carbon-500 bg-ontick-graphite-500 flex w-full items-center justify-between truncate border px-3 py-2 shadow-sm focus:outline-none"
      @click="isOptionsExpanded = !isOptionsExpanded"
      @blur="isOptionsExpanded = false"
      :disabled="disabled"
      :class="isOptionsExpanded ? 'rounded-t-md' : 'rounded-md'"
    >
      <span>{{
        options.filter((x) => x.param_id == selectedOption)[0].param_name
      }}</span>
      <svg
        fill="none"
        viewBox="0 0 24 24"
        stroke="#a0aec0"
        class="h-4 w-4 transform transition-transform duration-100 ease-in-out"
        :class="isOptionsExpanded ? 'rotate-180' : 'rotate-0'"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>
    <transition
      enter-active-class="transform transition duration-500 ease-custom"
      enter-class="-translate-y-1/2 scale-y-0 opacity-0"
      enter-to-class="translate-y-0 scale-y-100 opacity-100"
      leave-active-class="transform transition duration-300 ease-custom"
      leave-class="translate-y-0 scale-y-100 opacity-100"
      leave-to-class="-translate-y-1/2 scale-y-0 opacity-0"
    >
      <ul
        v-show="isOptionsExpanded"
        class="border-ontick-carbon-500 bg-ontick-steel-500 absolute left-0 right-0 z-50 mb-4 overflow-hidden rounded-b border shadow-lg"
      >
        <li
          v-for="(option, index) in options"
          :key="index"
          class="hover:bg-ontick-steel-700 cursor-pointer px-3 py-2 transition-colors duration-100"
          @mousedown.prevent="setOption(option)"
        >
          {{ option.param_name }}
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    selectedOption: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      isOptionsExpanded: false,
      selected: "",
    };
  },
  methods: {
    setOption(option) {
      this.$emit("change", option);
      this.isOptionsExpanded = false;
    },
  },
};
</script>

<style scoped>
.ease-custom {
  transition-timing-function: cubic-bezier(0.61, -0.53, 0.43, 1.43);
}
</style>
